import Button from "@mui/material/Button";
import RegisterIcon from "@mui/icons-material/AppRegistration";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import GoogleIcon from "@mui/icons-material/Google";
import GitHubIcon from "@mui/icons-material/GitHub";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";

import PersonIcon from "@mui/icons-material/Person";
import useAxios from "axios-hooks";
import Cookies from "js-cookie";
import {
    CreditCard,
    CreditCardTwoTone,
    EditTwoTone,
    KeyTwoTone,
    LaunchTwoTone,
    SmartToyTwoTone
} from "@mui/icons-material";
import PackagesImage from "./images/packages_vert.png";

export default function Profile() {
    const [emailAddress, setEmailAddress] = useState("");
    const [token, setToken] = useState("");
    const [data, setData] = useState("");

    // 1. Add state for the dropdown
    const [subscription, setSubscription] = useState("steel");

    const navigate = useNavigate();

    function toDateTime(ticks) {
        var t = new Date(1970, 0, 1); // Epoch
        t.setMilliseconds(ticks)
        return t;
    }

    function getPortalUrl() {
        return "../api/stripe/account?token=" + encodeURIComponent(token);
    }

    useEffect(() => {
        // Retrieve the auth token from the cookie
        const authToken = Cookies.get('auth');
        const emailAddress = Cookies.get('email');
        if (authToken && emailAddress) {
            authUser(authToken).then(r => {
                setToken(authToken);
                setEmailAddress(emailAddress)
                fetchUserDetails(emailAddress)
            });

        } else {
            window.location.href = './login';
        }
    }, []);


    const fetchUserDetails = async (email) => {
        try {
            const response = await fetch("../api/user/getUser?email=" + email, {
                method: 'GET'
            });
            if (response.ok) {
                const userData = await response.json();
                setData(userData);

                // 2. Sync the dropdown with the data from DB
                if(userData.subscription) {
                    setSubscription(userData.subscription);
                }
            } else {
                window.location.href = './login';
            }
        } catch (error) {
            window.location.href = './login';
        }
    };

    const authUser = async (authToken) => {
        const encodedAuthToken = encodeURIComponent(authToken);
        try {
            const response = await fetch('../api/user/auth?token=' + encodedAuthToken, {
                method: 'GET'
            });

            if (response.ok) {
                await response.json();
            } else {
                console.error('Auth failed:', response.status);
            }
        } catch (error) {
            console.error('Error during auth:', error);
        }
    };

    const fetchUserGrafanaSessions = async (token) => {
        const formData = new URLSearchParams();
        formData.append('token', token);
        try {
            const response = await axios.post('../api/grafana/getUserSessions', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response.status >= 200 && response.status < 300) {
                const sessions = response.data;
                return sessions;
            }
            return 0;
        } catch (error) {
            console.error("Error in fetchUserGrafanaSessions:", error);
            return 0;
        }
    };

    const handleManageSubClick = () => {
        if (data.stripeId) {
            window.location.href = `../api/stripe/account?token=${encodeURIComponent(token)}`;
        } else {
            window.location.href = "../api/stripe/checkout?email=" + data.emailAddress + "&sub=" + data.subscription;
        }
    };

    // 3. Handle new subscription submission
    const handleNewSubscription = async () => {
        // Only submit to stripe if package is NOT steel
        if (subscription && subscription !== "steel") {
            window.location.href = "../api/stripe/checkout?email=" + data.emailAddress + "&sub=" + subscription;
        } else if (subscription && subscription === "steel") {
            const formData = new URLSearchParams();
            formData.append('token', token);
            try {
                const response = await axios.post('../api/user/createBasePackage', formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
                navigate("../");
            } catch (error) {
                console.error(error);
            }
        } else {
            alert("Please select a paid package to subscribe.");
        }
    };


    return (

        <div className="Section">
            <div className="SectionLtr">

                <span className='SectionBox'>
                    <span className="SectionHeadingHolder">
                        <span className="SectionHeadingIcon"><PersonIcon sx={{ fontSize: 43 }} /></span>
                        <span className="SectionHeading">MEMBER</span>


                    </span>
                    <div className="_div_line_dual_grad"></div>
                    <div className="DataEntry">
                        <div className="DataHeading">Screen Name</div>
                        <div className="DataBodyLrg">{data.screenName}</div>
                    </div>
                    <div className="DataEntry">
                        <div className="DataHeading">E-mail</div>
                        <div className="DataBody">{data.emailAddress}</div>
                    </div>

                    <div className="DataEntry">
                        <div className="DataHeading">Date joined</div>
                        <div className="DataBodyThin">{toDateTime(data.timeCreated).toDateString()}</div>
                    </div>
                    <div className="_button_bar">
                        <div className="_button_holder">
                            <Link to="/edit"> <EditUserButton /></Link>
                        </div>
                        <div className="_button_holder">
                            <Link to="/pass"> <ChangePassButton /></Link>
                        </div>

                    </div>
                </span>
                <span className='SectionBox'>
                    <span className="SectionHeadingHolder">
                        <span className="SectionHeadingIcon"><RegisterIcon sx={{ fontSize: 43 }} /></span>
                        <span className="SectionHeading">SUBSCRIPTION</span>
                    </span>
                    <div className="_div_line_dual_grad"></div>

                    {/* View for active Paid Users */}
                    {(data.enabled && data.subscription !== "steel") && (
                        <div>
                            <div className="DataEntry">
                                <div className="DataHeading">Package</div>
                                <div className="DataBodyLrg">
                                    {data.subscription ? data.subscription.toUpperCase() : ''}
                                </div>
                            </div>
                            <div className="DataEntry">
                                <div className="DataHeading">Monthly Charge</div>
                                <div className="DataBody">
                                    {data.enabled ? ('$' + data.subPrice) : "Awaiting payment"}
                                </div>
                            </div>
                            <div className="_button_bar">
                                <div className="_button_holder">
                                    <Button onClick={handleManageSubClick} variant="outlined" startIcon={< CreditCardTwoTone />}>
                                        MANAGE SUBSCRIPTION
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* View for Free (Steel) or Disabled Users */}
                    {(!data.enabled || data.subscription === "steel") && (
                        <div>
                            <div className="_button_bar">
                                <div className="_button_bar_title">
                                    Select a package:
                                </div>

                                <select
                                    id="subscription"
                                    className="Select"
                                    value={subscription}
                                    onChange={e => setSubscription(e.target.value)}
                                >
                                    <option className="SelectItemTi" value="steel">STEEL - Free</option>
                                    <option className="SelectItemTi" value="aluminium">ALUMINIUM - $9.99</option>
                                    <option className="SelectItemTi" value="titanium">TITANIUM - $19.99</option>
                                    <option className="SelectItemTi" value="inconel">INCONEL - $29.99</option>
                                </select>

                                {(!data.enabled || subscription !== "steel") && (
                                <div className="_button_holder">
                                    <Button onClick={handleNewSubscription} variant="outlined" startIcon={<CreditCardTwoTone />}>
                                        SUBSCRIBE
                                    </Button>
                                </div>
                                )}
                            </div>
                        </div>
                    )}

                </span>

                {(!data.enabled || data.subscription === "steel") && (
                <span className="SectionBoxImagePort">
                    <img src={PackagesImage} alt="packages" className="SectionBoxImagePort" />
                </span>
                )}
                {data.enabled && (
                <div className="_button_bar">
                    <span className="_button_holder">
                        <Link to="/"> <LaunchAppButton /></Link>
                    </span>
                </div>
                )}
            </div>

        </div>
    );
}


function EditUserButton() {
    return (
        <Button variant="outlined" startIcon={< EditTwoTone />}>
            SCREEN NAME
        </Button>
    );
}

function ChangePassButton() {

    return (
        <Button variant="outlined" startIcon={< KeyTwoTone />}>
            EDIT PASSWORD
        </Button>
    );
}

function AgentLicensesButton() {

    return (
        <Button variant="outlined" startIcon={< SmartToyTwoTone />}>
            AGENT LICENSES
        </Button>
    );
}
function LaunchAppButton() {

    return (
        <Button type="submit" variant="contained" startIcon={< LaunchTwoTone />}>
            LAUNCH APP
        </Button>
    );
}

function PackageButton() {

    return (
        <Button type="submit" variant="contained" startIcon={< RegisterIcon />}>
            Edit Package
        </Button>
    );
}